import { Component, OnInit } from '@angular/core';
import { Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import { ThingSettingsComponent, DialogDataUser } from "src/app/dashboard/things/thing-settings/thing-settings.component"
@Component({
  selector: 'app-add-number-dialog',
  templateUrl: './add-number-dialog.component.html',
  styleUrls: ['./add-number-dialog.component.css']
})
export class AddNumberDialogComponent implements OnInit {
  datainput: string;
  constructor(
    public dialogRef: MatDialogRef<ThingSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataUser
  ) { }

  ngOnInit() { }
  onNoClick(): void {
    this.dialogRef.close();
  }
}